import { TYPE_CONSTRUCTION } from '../model';

export default factory;

function factory() {
  return (value) => {
    switch (value) {
      case TYPE_CONSTRUCTION.EOLIENNE:
        return 'Eolienne';
      case TYPE_CONSTRUCTION.IMMEUBLE:
        return 'Immeuble';
      default:
        return '';
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/common/filters/type-construction.filter.js